function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.25,
  stroke: "#22253F",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71689 6.2312C6.97923 4.89694 7.89838 5.5011 8.32517 5.96997C9.07242 6.69432 7.99278 8.7918 6.70795 8.53919C5.42312 8.28658 6.38898 7.89903 6.71689 6.2312Z",
  fill: "#22253F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.508 2.00307C10.1503 2.7282 9.25057 3.40793 8.59539 3.65716C7.57 4.12757 5.08857 2.33961 5.60022 1.18079C6.11187 0.0219672 6.45508 1.09666 8.508 2.00307Z",
  fill: "#22253F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.36488 4.97041C4.72636 3.70935 3.31054 3.13136 2.55744 3L0.75 5.36449L1.65372 8.12307C1.95496 8.77987 2.82855 10.0147 3.91302 9.6994C5.2686 9.30532 3.91302 7.72899 3.46116 6.94082C3.0093 6.15266 3.91302 6.54674 4.36488 4.97041Z",
  fill: "#22253F"
});

var SvgWorld = function SvgWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world.60fa5728.svg";
export { ForwardRef as ReactComponent };